export const ITEM_CATEGORIES = Object.freeze([
    "FOOD",
    "WATER",
    "MEDICAL",
    "MATERIAL",
    "COMPONENT",
    "ELECTRONICS",
    "TOOL",
    "CLOTHING",
    "AMMUNITION",
    "WEAPON",
    "KEY_ITEM",
    "MISC",
]);
export const ITEM_TAGS = Object.freeze([
    "METAL",
    "ORGANIC",
    "ELECTRONIC",
    "SALVAGE",
    "FOOD",
    "DRINK",
    "MEDICAL",
    "BATTERY",
    "TOOL",
    "FABRIC",
    "FUEL",
    "PLASTIC",
    "FASTENER",
    "SEALED",
]);
export const ITEM_SCARCITIES = Object.freeze([
    "COMMON",
    "UNCOMMON",
    "SCARCE",
    "RARE",
    "EXPERIMENTAL",
]);
export const ITEM_ICON_KEYS = Object.freeze([
    "can",
    "food_bar",
    "bottle",
    "medical",
    "metal",
    "fabric",
    "tape",
    "rubber",
    "wire",
    "fastener",
    "component",
    "battery",
    "circuit",
    "cable",
    "phone",
    "tool",
    "misc",
    "flashlight",
    "jeans",
]);
export const ITEM_WORLD_ASSET_IDS = Object.freeze([
    "small_can",
    "water_bottle",
    "cloth_bundle",
    "scrap_bundle",
    "battery_bundle",
    "small_tool",
    "pickup_bundle",
    "flashlight_basic",
]);
export const ITEM_CONDITION_MODELS = Object.freeze(["NONE", "DURABILITY"]);
export const EQUIPMENT_SLOTS = ["HEAD", "FACE", "TORSO_BASE", "TORSO_OUTER", "LEGS", "FEET", "HANDS"];
export const PLAYER_INVENTORY_SLOT_COUNT = 24;
export const PLAYER_MAX_MASS_GRAMS = 30_000;
export const SUPPLY_CACHE_SLOT_COUNT = 12;
export const WORLD_DROP_LIFETIME_MS = 30 * 60 * 1_000;
export const WORLD_DROP_INTEREST_RADIUS = 96;
export const WORLD_DROP_CELL_SIZE = 32;
export const WORLD_DROP_MAX_GLOBAL = 4_096;
export const WORLD_DROP_MAX_PER_PLAYER = 96;
